import { Navigate } from "react-router-dom";
import { LoaderCircle } from "lucide-react";
import { usePrivy } from "@privy-io/react-auth";
import { Role, useAuthContext } from "@/components/AuthorizationProvider";
import { PropsWithChildren } from "react";
import { useAuth } from "@/hooks/use-auth";
import { featureQueries } from "@/api/api";
import { useQuery } from "@tanstack/react-query";

const PrivatePreviewRoute = ({
  children,
  feature,
}: PropsWithChildren<{ feature: string }>) => {
  const { authenticated, ready, user } = usePrivy();
  const { userAuthorization } = useAuthContext();
  const { hasAtLeastRole } = useAuth();

  // Check if user has the roles super_admin or tenant_admin
  const isAdmin = hasAtLeastRole(Role.TenantAdmin);

  const { data: users = [] } = useQuery(featureQueries.permissions(feature));

  const isAllowedUser = isAdmin || users.includes(user?.id ?? "");

  return !ready || (authenticated && !userAuthorization) ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <LoaderCircle className="h-12 w-12 animate-spin stroke-accent m-auto" />
    </div>
  ) : authenticated && userAuthorization && isAllowedUser ? (
    children
  ) : (
    <Navigate to="/" />
  );
};

export default PrivatePreviewRoute;
